import RegionVaccinationBlock from './RegionVaccinationBlock';

export default RegionVaccinationBlock;
